import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.sass']
})
export class AdminDashboardComponent implements OnInit {

  constructor(private authservice: AuthService, private router: Router) { }

  ngOnInit() {
  }

  logout() {
    this.authservice.logout({}).subscribe(data => {
      if (data["status"] == 200 || data["status"] == 221) {
        this.router.navigate(['/']);
      } else {
        alert(data["message"]);
      }
    });
  }

}
